import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import {translate} from 'react-admin';
import {apiUrl} from '../config';

class MakeSpaceBarcodeButton extends Component {
    
    handleClick = (event) => {
        event.stopPropagation();
        const { record } = this.props;
        window.open(apiUrl + '/spaces/make.php?auth='+JSON.parse(localStorage.getItem('lbtoken')).value.id+'&barcode='+record.barcode);  
    }

    render() {
        return (
        <div>
            <Button label="MakeSpaceBarcode" onClick={this.handleClick} color="primary" variant="raised">{this.props.record.status === "printed_boxmark" ? this.props.translate('resources.purchases.actions.viewboxmark') : this.props.translate('resources.spaces.makebarcode')}</Button>
        </div>
        );
    }
}

MakeSpaceBarcodeButton.propTypes = {
    record: PropTypes.object,

};

const enhance = compose(
    translate
);

export default enhance(MakeSpaceBarcodeButton);